<script>
import Popper from "vue3-popper";
import { useToast } from "vue-toastification";



import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getProject, saveProject, createProject} from '@/services/working/serviceProject';

import { getStateOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ProjectEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		Popper
		,LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'projectId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["projectId","changeRecord"],
	data() {
	
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,

			optionsAccessLevels: [],
			optionsTypes:[],
			optionsTemplates:[],
			optionsStates:[],
			optionsLanguages:[],
			
			initObj: {
				
				relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:450
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
			},
			
						
			//form
			data:[]
			
			
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true

			getProject({projectId:this.projectId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		
		onClose:function(){
			this.$emit('changeRecord', '')
			this.modalObject.hide();
		},
		

		checkSave:function(){
								
			if(!this.data.title){this.data.titleError = true; }else{this.data.titleError = false;}
							
			if(this.data.title){
				return true;
			}else{
				this.toast.warning(this.$t('msgCore.fillInAllData'));
				return false;
			}
		},	
		
		onSave:function(){
			
			if(this.checkSave()){
				if(this.projectId!='null'){	
					this.isSending=true
					saveProject(this.data).then(response => {
						if(!response.statusText){
							this.isSending=false
							console.log(response)
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{
					createProject(this.data).then(response => {
						if(!response.statusText){
							this.isSending=false
							console.log(response)
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			}
			
		}
	
		
	},
	
	watch: {
		projectId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCustomWorking.Project') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.projectsEdit || auth.projectsNew)" class="modal-body">
											
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>

									<div class="form-row">
										
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCore.title') }}</b> </label>
											<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.titleError}" v-on:change="checkSave()" v-model="data.title" >
											<div v-show="data.titleError" class="error-input">vyplňte</div>
										</div>
										
										
										<div class="form-group col-md-12 col-12">
											<label><b>{{ $t('msgCore.description') }}</b></label>
											<input type="text" class="form-control form-control-sm" v-model="data.description" >
										</div>
										
										<div class="form-group col-12">
											<label><b>{{ $t('msgCore.url') }}</b></label>
											<input type="text" class="form-control form-control-sm" v-model="data.url">
										</div>
										
										<div class="form-group col-12">
											<label><b>{{ $t('msgCustomWorking.UrlAdmin') }}</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.url_admin" >
										</div>
										
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCustomWorking.Hosting') }}</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.hosting" >
										</div>
										
										<div class="form-group col-md-6 col-12">
											<label><b>{{ $t('msgCustomWorking.Platform') }}</b></label>
											<input type="text" class="form-control form-control-sm" v-model="data.platform">
										</div>
										
									</div>	
								
									
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							
							
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="((!auth.projectsEdit) || (!auth.projectsNew) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		

	</div>
	

</template>


